// src/hooks/useAccess.js
import { useState, useEffect } from "react";
import { useDataAuth } from "./useDataAuth";
import { getAccessScreen } from "../services/common.services";
 
export function useAccess(menu, id_company = "", setLoading=null) {
    const [{ userSession }] = useDataAuth();
    const [access, setAccess] = useState({});
    const [loadingAccess, setLoadingAccess] = useState(true);
 
    useEffect(() => {
        const fetchAccess = async () => {
            if (!userSession?.token) return;
            if (setLoading) setLoading(true);
            setLoadingAccess(true);
            try {
                const response = await getAccessScreen(menu, id_company, userSession.token);
                if (response.status === 200 && response?.data) {
                    const parsedAccess = {};
                    (Array.isArray(response.data) ? response.data : [response.data]).forEach((item) => {
                        switch (item.work_flow) {
                            case "ACCESS_VIEW_ALL":
                                parsedAccess.viewAll = true;
                                break;
                            case "ACCESS_CHANGE_RESPONSABILITY":
                                parsedAccess.changeResponsability = true;
                                break;
                            case "ACCESS-REQUEST_LOCATION":
                                parsedAccess.requestLocation = item.work_flow;
                                break;
                            case "ACCESS-REQUEST_LOCATION_FOLLOW_UP":
                                parsedAccess.requestLocationFollowUp = item.work_flow;
                                break;
                            default:
                                parsedAccess[item.work_flow] = true;
                                break;
                        }
                    });
                    setAccess(parsedAccess);
                }
            } catch (err) {
                console.error("Error fetching access:", err);
            } finally {
                if (setLoading) setLoading(false);
                setLoadingAccess(false);
            }
        };
        fetchAccess();
    }, [menu, userSession.token, id_company, setLoading]);
 
    return { access, loadingAccess };
}